<script setup></script>
<template>
    <v-card>
        <template v-if="loading">
            <v-progress-linear height="10" indeterminate></v-progress-linear>
        </template>

        <template v-else>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{ subscription.client.name }} subscription</v-toolbar-title>
                <v-btn
                    :href="subscription.stripe_url"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    icon
                >
                    <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <v-list-item three-line>
                            <v-list-item-content>
                                <v-list-item-title>Tier</v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ subscription.name }}
                                    <v-chip
                                        :color="subscriptionStatusMap[subscription.stripe_status].color"
                                        :text-color="subscriptionStatusMap[subscription.stripe_status].text"
                                        x-small
                                    >{{ subscriptionStatusMap[subscription.stripe_status].name }}</v-chip>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    ${{subscription.price.amount }} / {{ subscription.price.interval }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Latest invoice</v-list-item-title>
                                <v-list-item-subtitle>
                                    <a :href="subscription.invoice_url">Download PDF</a>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Created</v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ subscription.created }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>

                    <v-col v-if="subscription.ends" cols="12" md="6">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>{{ endsTitle }}</v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ endsDate }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Current period</v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ subscription.current_period_start }} to {{ subscription.current_period_end }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Payment method</v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ subscription.payment_method.card.brand }} •••• {{ subscription.payment_method.card.last4 }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-card-text>
        </template>
    </v-card>
</template>

<script>
import { subscriptionStatusMap } from '@/subscriptionStatuses'

export default {
    name: 'SubscriptionDialog',
    props: {
        subscription: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data: () => ({
        subscriptionStatusMap,
    }),
    computed: {
        loading() {
            return this.subscription === null
        },
        endsTitle() {
            const ended = new Date(this.subscription.ends) < new Date()

            return ended ? 'Ended' : 'Ends'
        },
        endsDate() {
            return new Date(this.subscription.ends).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
            })
        }
    },
}
</script>